// authSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface User {
  name: string;
  phone: string;
}

interface AuthState {
  isLoggedIn: boolean;
  user: User | null;
  sessionActive: boolean;
}

const initialState: AuthState = {
  isLoggedIn: false,
  user: null,
  sessionActive: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<User>) => {
      state.isLoggedIn = true;
      state.user = action.payload;
      state.sessionActive = true;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.sessionActive = false;
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
